<template>
  <sweet-modal ref="modal" overlay-theme="dark">
    <div
      class="message-display py-4"
      ref="unReadMessageDisplay"
      :style="`height:${windowHeight}px; font-size: 80%;`"
      style="text-align: justify"
      @scroll.passive="handleMessageScrollOnlyCustomer"
      v-if="messages"
    >
      <div v-for="(message, index) in messages" :key="message.id || 'loading-' + index">
        <customer-chat :message="message" v-if="message.own === 0" />
        <admin-chat :message="message" v-else />
      </div>
    </div>
  </sweet-modal>
</template>
<script>
import AdminChat from '@/components/coversation/AdminChat'
import CustomerChat from '@/components/coversation/CustomerChat'
import axios from 'axios'
export default {
  components: {
    AdminChat,
    CustomerChat
  },
  data: () => ({
    page: 0,
    messages: null,
    windowHeight: window.innerHeight - 160,
    conversationId: null
  }),
  methods: {
    openModal (conversation) {
      this.loadFirstMessages(conversation.id)
      this.conversationId = conversation.id
      this.$refs.modal.open()
    },
    async loadFirstMessages (conversationId) {
      // Load messages
      this.page = 0
      const params = {
        conversation_id: conversationId,
        page: this.page
      }
      await this.fetchMessages(params)
    },
    async loadMoreMessages (conversationId) {
      this.page = this.page + 1
      const params = {
        conversation_id: conversationId,
        page: this.page
      }
      await this.fetchMessages(params)
    },
    async fetchMessages (params) {
      const url = '/messages'
      try {
        const res = await axios.get(url, { params })
        if (res.status === 200) {
          const messages = res.data
          if (messages.length > 0) {
            const timeout = this.page === 0 ? 300 : 1000
            this.messages =
              this.page === 0 ? messages : [...messages, ...this.messages]
            await new Promise(resolve => setTimeout(resolve, timeout))
            const scrollHeight =
              this.page === 0
                ? this.$refs.unReadMessageDisplay.scrollHeight
                : this.$refs.unReadMessageDisplay.scrollHeight -
                  this.contentHeight
            this.$refs.unReadMessageDisplay.scrollTop = scrollHeight
          }
        }
      } catch (error) {
        this.$swal('Error', error.message, 'error')
      }
    },
    async handleMessageScrollOnlyCustomer ({
      target: { scrollTop, clientHeight, scrollHeight }
    }) {
      if (scrollTop === 0) {
        this.contentHeight = scrollHeight
        if (this.conversationId) {
          await this.loadMoreMessages(this.conversationId)
        }
      }
    }
  }
}
</script>
